import listActions from 'src/modules/categoriaProducto/list/categoriaProductoListActions';
import CategoriaProductoService from 'src/modules/categoriaProducto/categoriaProductoService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'CATEGORIAPRODUCTO_DESTROY';

const categoriaProductoDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaProductoDestroyActions.DESTROY_STARTED,
      });

      await CategoriaProductoService.destroyAll([id]);

      dispatch({
        type: categoriaProductoDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.categoriaProducto.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/categoria-producto');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: categoriaProductoDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaProductoDestroyActions.DESTROY_ALL_STARTED,
      });

      await CategoriaProductoService.destroyAll(ids);

      dispatch({
        type: categoriaProductoDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.categoriaProducto.destroyAll.success'),
      );

      getHistory().push('/categoria-producto');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: categoriaProductoDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default categoriaProductoDestroyActions;
